import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Col } from 'react-flexbox-grid';
import { Checkbox } from 'material-ui';

import { get } from 'lodash';
import { fetch, fetchHolidayOverview, requestHolidayInfo } from 'actions/EmployeeHoliday';
import HolidayEntry from 'components/HolidayEntry';
import PanelMessage from 'components/panels/PanelMessage';
import Loading from 'components/Loading';
import { getSettingByKey, setSettingByKey } from 'utils/localSettings';
import styles from 'styles/EmployeeHoliday';
import { fetchHolidayByYear } from '../actions/EmployeeHoliday';
import KTitle from '../components/KJRN/KTitle';
import SelectComponent from '../components/SelectComponent';

const HOLIDAY_LOCAL_KEY = 'showHolidayByHour';

const EmployeeHoliday = ({
  loaded,
  error,
  hasError,
  holidays,
  holidayOverview,
  overviewLoaded,
  fetchInfo,
  fetchByYear,
  holidayPayYear,
  fetchingByYear,
  earnedHolidayInfo,
}) => {
  const { language } = useSelector(state => state.languageReducer);
  const [showByHour, setShowByHour] = useState(getSettingByKey(HOLIDAY_LOCAL_KEY) || false);
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(2025);
  const holiday = get(holidays, '0', null);

  useEffect(() => {
    if (holidayPayYear) {
      setSelectedYear(holidayPayYear);
      const years = [
        holidayPayYear,
        holidayPayYear - 1,
      ];
      setYearOptions(years);
    }
  }, [holidayPayYear]);

  useEffect(() => {
    fetchInfo();
  }, []);

  const toggleShowByHour = () => {
    setSettingByKey(HOLIDAY_LOCAL_KEY, !showByHour);
    setShowByHour(!showByHour);
  };

  const onFetchByYear = (year) => {
    const yearNumber = parseInt(year, 10);
    setSelectedYear(yearNumber);
    fetchByYear(yearNumber);
  };

  const holidaySelect = (
    <div style={{ marginBottom: 9, textAlign: 'center' }}>
      <SelectComponent
        value={selectedYear}
        onChange={onFetchByYear}
        options={yearOptions.map(year => ({ value: year, label: `${language === 'is' ? 'Orlofsárið ' : 'Vacation '} ${year}` }))}
      />
    </div>
  );

  if (!loaded || !overviewLoaded) {
    return <Loading />;
  }

  if (hasError) {
    return (
      <Col xs={12} sm={12} md={6} mdOffset={3}>
        <PanelMessage
          type="error"
          iconName="error"
          message={error.Message || <FormattedMessage id="holiday.error" />}
        />
      </Col>
    );
  }

  if ((!holidays || !holidays.length) && !earnedHolidayInfo) {
    return (
      <Col xs={12} sm={12} md={6} mdOffset={3}>
        <PanelMessage
          type="info"
          iconName="info"
          message={<FormattedMessage id="tile.holiday.empty" />}
        />
      </Col>
    );
  }

  return (
    <div style={styles.content}>
      <div style={styles.header}>
        <div>
          <KTitle containerStyle={{ maxWidth: 1400, margin: 'auto' }} key="hb" title={<FormattedMessage id="holiday.title" />} />
        </div>
        <div style={styles.checkbox}>
          <Checkbox
            onCheck={toggleShowByHour}
            checked={showByHour}
            label={<FormattedMessage id="holiday.showByHour" />}
            labelPosition="right"
          />
        </div>
      </div>
      <Col style={styles.wrap} xs>
        <HolidayEntry
          showByHour={showByHour}
          earnedHolidayInfo={earnedHolidayInfo}
          Overview={holidayOverview}
          fetchingByYear={fetchingByYear}
          selectedYear={selectedYear}
          selectComponent={holidaySelect}
          {...holiday}
        />
      </Col>
    </div>
  );
};

EmployeeHoliday.propTypes = {
  loaded: PropTypes.bool.isRequired,
  holidays: PropTypes.array.isRequired,
  holidayOverview: PropTypes.object,
  overviewLoaded: PropTypes.bool.isRequired,
  error: PropTypes.object,
  hasError: PropTypes.bool.isRequired,
  fetchInfo: PropTypes.func.isRequired,
  fetchByYear: PropTypes.func.isRequired,
  holidayPayYear: PropTypes.number.isRequired,
  earnedHolidayInfo: PropTypes.object.isRequired,
  fetchingByYear: PropTypes.bool.isRequired,
};

EmployeeHoliday.defaultProps = {
  error: null,
  holidayOverview: {},
};

const mapStateToProps = ({ EmployeeHolidayReducer }) => ({ ...EmployeeHolidayReducer });

export default connect(
  mapStateToProps,
  dispatch => ({
    fetchByYear: (year) => {
      dispatch(fetchHolidayByYear(year));
    },
    fetchInfo: () => {
      dispatch(fetch());
      dispatch(fetchHolidayOverview());
      dispatch(requestHolidayInfo());
    },
  }),
)(EmployeeHoliday);



// WEBPACK FOOTER //
// ./src/containers/EmployeeHoliday.js